import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { CheckBox as BaseCheckBox } from '@ubeya/shared-web/components';

const CheckBox = styled(BaseCheckBox)`
  margin-left: -10px;
`;

const SharedWithClientToggleRenderer = ({ dataKey, rowData, columnData: { onChange } }) => {
  if (!rowData.positionId) {
    return <></>;
  }
  const value = get(rowData, dataKey);

  return (
    <CheckBox
      value={value}
      name={`${dataKey}-${rowData.positionId}`}
      onChange={(val) => {
        onChange(rowData.positionId, val);
      }}
    />
  );
};

export default SharedWithClientToggleRenderer;
